import { faCalendarPlus, faCircleCheck } from "@fortawesome/pro-regular-svg-icons";

import { useMatch } from "common/router/hooks";
import Icon from "common/components/Icon";
import { pluralized } from "common/utils/strings";
import { parseNumber } from "common/utils/numbers";

import Page from "client/common/components/layouts/Page";
import Button from "client/common/components/buttons/Button";
import { Paths } from "client/routes";
import LoadingContainer from "client/common/components/loading/LoadingContainer";
import FetchErrorContainer from "client/common/components/errors/FetchErrorContainer";
import Header from "client/common/components/header/Header";

import { downloadIcsForAppointments } from "../utils/calendar";
import AppointmentBookingAppointment from "./AppointmentBookingAppointment";
import { useAppointmentsQuery } from "../hooks";

import styles from "../styles/AppointmentBookingConfirm.module.less";

const AppointmentBookingConfirm = () => {
  const match = useMatch<Paths["scheduler"]["book"]>();

  const appointmentIds = (match.search.appointment_ids ?? "")
    .split(",")
    .filter(Boolean)
    .map(parseNumber);

  const {
    data: appointments = [],
    isLoading,
    error,
  } = useAppointmentsQuery(
    { appointment_ids: appointmentIds },
    { enabled: appointmentIds.length > 0 },
  );

  const addToCalendar = () => {
    downloadIcsForAppointments(appointments);
  };

  return (
    <Page Header={<Header />} Footer={null} className={styles.page}>
      <div className={styles.content}>
        {isLoading && <LoadingContainer />}
        {error && (
          <FetchErrorContainer
            error={error}
            entityName="appointment"
            isPlural={appointmentIds.length > 1}
          />
        )}
        {appointments?.length > 0 && (
          <div>
            <div className={styles.header}>
              <Icon icon={faCircleCheck} className={styles.icon} />
              <div>{pluralized(appointments.length, "Appointment")} confirmed!</div>
            </div>
            <div className={styles.appointments}>
              {appointments.map((appt) => (
                <AppointmentBookingAppointment appoinment={appt} key={appt.id} />
              ))}
            </div>
            <div className={styles.buttons}>
              <Button onClick={addToCalendar}>
                <Icon icon={faCalendarPlus} /> Add to calendar
              </Button>
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};

export default AppointmentBookingConfirm;
